// A backend restart (scripts/deploy.sh restart-backend) leaves the API
// unreachable for ~10-30s. Pages that load in that window got a 502/503 for
// every data call and rendered empty tables until a manual refresh. Retry
// API GETs through it instead. Only GETs: retrying a POST could double-act.
const RETRY_STATUSES = new Set([502, 503, 504])
const GIVE_UP_AFTER_MS = 60_000

const isApiGet = (input, init) => {
  const isRequestObject = typeof Request !== 'undefined' && input instanceof Request
  const url = isRequestObject ? input.url : String(input)
  const method = (init.method || (isRequestObject ? input.method : 'GET')).toUpperCase()
  return method === 'GET' && url.includes('/api/') && !isRequestObject
}

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export function installFetchRetry() {
  const originalFetch = window.fetch.bind(window)

  window.fetch = async (input, init = {}) => {
    if (!isApiGet(input, init)) return originalFetch(input, init)

    const started = Date.now()
    for (let attempt = 1; ; attempt++) {
      let response
      try {
        response = await originalFetch(input, init)
      } catch (err) {
        if (err.name === 'AbortError' || Date.now() - started > GIVE_UP_AFTER_MS) throw err
      }
      if (response && (!RETRY_STATUSES.has(response.status) || Date.now() - started > GIVE_UP_AFTER_MS)) {
        return response
      }
      await wait(Math.min(attempt, 5) * 1000)
    }
  }
}
